import { Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  bindDropDown,
  callAPI,
  convertToUTCISOString,
  dateFormat,
  getLocalValue,
  IsSmallScreen,
  LoacalVariables,
  Method
} from "../../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../../Components/AutoComplete/AutoComplete";
import {
  HeaderList,
  IHeaderListActions
} from "../../../../Components/Header/HeaderList";
import WSSelectField from "../../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../../Components/Snackbar/SnackBarContext";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import config from "../../../../Config/clientConfig.json";
import WSDateField from "../../.././../Components/DateField/WSDateField";
import dayjs from "dayjs";

export const CreateDeals: React.FC<any> = (props) => {
  const { showMessage } = useSnackbar();
  const { id } = useParams();
  const [leadData, setLeadData] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = IsSmallScreen();
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
  useEffect(() => {
    try {
      async function getLeads() {
        const response: any = await bindDropDown(
          "leads",
          "firstName",
          "id",
          Method.GET,
          ["firstName", "lasttName"],
          { field: "leadType", value: 0 }
        );
        setLeadData(response);
      }
      getLeads();
    } catch (e) {}
  }, []);
  useEffect(() => {
    try {
      async function getDeals() {
        const response: any = await callAPI("deals", Method.GET, null, id);
        if (response) {
          const dealsData: any = response;
          setValue("dealName", dealsData?.dealName);
          setValue("amount", dealsData?.amount);
          setValue("stage", dealsData?.stage);
          setValue("status", dealsData?.status);
          setValue(
            "closeDate",
            dateFormat(response?.closeDate, "DD-MM-YYYY HH:mm:ss")
          );
          setValue("leadId", dealsData?.leadId);
          setValue("dealOwner", dealsData?.dealOwner);
          setValue("customerType", dealsData?.customerType);
          setValue("nextStep", dealsData?.nextStep);
          setValue("source", dealsData?.source);
          setValue("profitability", dealsData?.profitability);
          setValue("expectedRevenue", dealsData?.expectedRevenue);
          setValue("campaignSource", dealsData?.campaignSource);
          setValue("notes", dealsData?.notes);
        }
      }
      getDeals();
    } catch (e) {}
  }, [id]);
  const handleCancelClick = () => {
    navigate(`/deals/list`);
  };
  const handleDataSaveAndNew = async (data: any) => {
    try {
      setLoadingSaveAndNew(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          reset();
        }
      } else if (response?.id) {
        reset();
        showMessage("Deals Updated Successfully", "success");
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoadingSaveAndNew(false);
    }
  };
  const handleData = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await saveData(data);
      if (response && response?.message) {
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
        if (response.success === true) {
          navigate(`/deals/list`);
        }
      } else if (response?.id) {
        showMessage("Deals Updated Successfully", "success");
        navigate(`/deals/list`);
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };
  const saveData = async (data: any) => {
    const formattedDateTime: any = dayjs(
      `${data?.closeDate} 00:00`,
      "DD-MM-YYYY HH:mm"
    ).toISOString();
    const request: any = {
      dealName: data?.dealName || "",
      amount: Number(data?.amount) || "",
      stage: data?.stage || "",
      status: data?.status || "",
      closeDate: formattedDateTime || "",
      leadId: data.leadId || "",
      dealOwner: getLocalValue(LoacalVariables.UserId),
      customerType: data?.customerType || "",
      nextStep: data?.nextStep || "",
      source: data?.source || "",
      profitability: Number(data?.profitability) || 0,
      expectedRevenue: Number(data?.expectedRevenue) || 0,
      campaignSource: data?.campaignSource || "",
      notes: data?.notes || ""
    };
    if (id) {
      const request: any = {
        DealName: data?.dealName || "",
        Amount: Number(data?.amount) || "",
        Stage: data?.stage || "",
        Status: data?.status || "",
        CloseDate: formattedDateTime || "",
        LeadId: data.leadId || "",
        DealOwner: getLocalValue(LoacalVariables.UserId),
        CustomerType: data?.customerType || "",
        NextStep: data?.nextStep || "",
        Source: data?.source || "",
        Profitability: Number(data?.profitability) || 0,
        ExpectedRevenue: Number(data?.expectedRevenue) || 0,
        CampaignSource: data?.campaignSource || "",
        Notes: data?.notes || ""
      };
      const response: any = await callAPI("deals", Method.PATCH, request, id);
      return response;
    } else {
      const response: any = await callAPI("deals", Method.POST, request);
      return response;
    }
  };
  const actions: IHeaderListActions[] = [
    {
      type: "button",
      text: "Cancel",
      size: "small",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "primary"
    },
    {
      type: "button",
      disabled: id !== undefined,
      text: "Save & New",
      loading: loadingSaveAndNew,
      size: "small",
      onClick: handleSubmit(handleDataSaveAndNew),
      buttonType: "button",
      variant: "outlined",
      color: "primary"
    },
    {
      type: "button",
      text: "Save",
      loading: loading,
      size: "small",
      onClick: handleSubmit(handleData),
      buttonType: "submit",
      variant: "outlined",
      color: "primary"
    }
  ];
  const source = {
    url: "leads/search",
    page: 1,
    pageSize: 10000000,
    filter: [],
    sort: []
  };
  const transFormData = (data: any) => {
    const optionLeads: Array<any> = [];
    if (data) {
      data.map((item: any) => {
        optionLeads.push({
          label: `${item?.firstName} ${item?.lasttName || ""}`,
          value: item?.id
        });
      });
    }
    return optionLeads;
  };
  return (
    <Grid>
      <HeaderList
        title={!id ? "Create New Deal" : "Update Deal"}
        type="card"
        position="relative"
        actions={actions}
        isBackButton={true}
        url="/deals/list"
      />
      {
        <Card
          sx={
            {
              // borderRadius: "10px",
              // padding: 3,
              // marginTop: "-40px",
              // height: "25rem"
            }
          }
        >
          <CardContent>
            <form>
              <Grid container spacing={2} mt={0}>
                <Grid item xs={12}>
                  <Typography style={{ fontSize: ".9rem" }} fontWeight={"bold"}>
                    Deal Information
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Deal Name"}
                    {...register("dealName")}
                    id="dealName"
                    name="dealName"
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Amount"}
                    {...register("amount")}
                    id="amount"
                    name="amount"
                    control={control}
                    rules={{ required: true }}
                    type={TextType.Currency}
                    currency={CurrencyType.Rupee}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                    label={"Stage"}
                    {...register("stage")}
                    isMobile={isMobile}
                    id="stage"
                    name="stage"
                    options={[{ label: "New", value: "new" }]}
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                    label={"Customer Type"}
                    {...register("customerType")}
                    id="customerType"
                    name="customerType"
                    options={config.customertypeconfig.staticOptionData}
                    control={control}
                    isMobile={isMobile}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSDateField
                    id="closeDate"
                    name="closeDate"
                    label={"Closing Date"}
                    dateFormat="DD-MM-YYYY"
                    denyFuturOrPast="custom"
                    control={control}
                    setValue={setValue}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid item xs={12} sm={12}>
                    <WSAutocompleteField
                      source={source}
                      rules={{ required: true }}
                      {...register("leadId")}
                      id="leadId"
                      transFormData={transFormData}
                      isMobile={isMobile}
                      control={control}
                      label="Lead"
                      name="leadId"
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                    options={config.leadSourceConfig.staticOptionData}
                    rules={{ required: true }}
                    {...register("source")}
                    id="source"
                    isMobile={isMobile}
                    control={control}
                    defaultValue={"0"}
                    label="source"
                    name="source"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Probability(%)"}
                    {...register("profitability")}
                    id="profitability"
                    name="profitability"
                    control={control}
                    rules={{ required: true }}
                    type={TextType.Number}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Next Step"}
                    {...register("nextStep")}
                    id="nextStep"
                    name="nextStep"
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Expected Revenue"}
                    {...register("expectedRevenue")}
                    id="expectedRevenue"
                    name="expectedRevenue"
                    control={control}
                    rules={{ required: true }}
                    type={TextType.Currency}
                    currency={CurrencyType.Dollar}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <WSTextField
                    label={"Campaign Source"}
                    {...register("campaignSource")}
                    id="campaignSource"
                    name="campaignSource"
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                    label={"Status"}
                    {...register("status")}
                    isMobile={isMobile}
                    id="status"
                    name="status"
                    options={[{ label: "New", value: "new" }]}
                    control={control}
                    rules={{ required: true }}
                  />
                </Grid>
                <Grid item xs={12} mt={2}>
                  <Typography fontWeight={"bold"}>
                    Description Information
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <WSTextAreaField
                    label="Description"
                    id="notes"
                    control={control}
                    {...register("notes")}
                    rules={{ required: true }}
                    name="notes"
                    rows={2}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={12}>
                        <Divider />
                    </Grid> */}
                {/* <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton className="ws-theme-crm" loading={reduxComponentData?.data?.loading} variant="outlined" id='dealSubmit' label={"Save"} type="submit" size="medium" />
                        </Grid>
                        <Grid item sx={{ marginRight: 0 }}>
                            <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                        </Grid>
                    </Grid> */}
              </Grid>
            </form>
          </CardContent>
        </Card>
      }
    </Grid>
  );
};
